// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"107":"5f14f8dd","266":"85c91d6f","373":"6476cfa0","571":"c13232ba","970":"5be454ea"}[chunkId] + ".css";
};